import { initializeApp } from 'firebase/app';
import {
    getAuth,
    indexedDBLocalPersistence,
    browserLocalPersistence,
    initializeAuth,
    Auth
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { Capacitor } from '@capacitor/core';

// Firebase configuration
const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyB5NJynPJspmTA2bT_xC16W-HmMis5NLmI",
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "binit-a1585.firebaseapp.com",
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "binit-a1585",
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "binit-a1585.firebasestorage.app",
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "1036772679852",
    appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:1036772679852:web:1c0c64aa28f2b55be17f09"
};

// Log Firebase config (without exposing full keys)
console.log('[Firebase] Initializing with config:', {
    apiKey_present: !!firebaseConfig.apiKey,
    apiKey_len: firebaseConfig.apiKey?.length,
    apiKey_prefix: firebaseConfig.apiKey?.substring(0, 10) + '...',
    authDomain: firebaseConfig.authDomain,
    projectId: firebaseConfig.projectId
});

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth with appropriate persistence for platform
// On iOS/Capacitor, we need to use indexedDBLocalPersistence to avoid issues
let auth: Auth;
if (Capacitor.isNativePlatform()) {
    console.log('[Firebase] Using indexedDBLocalPersistence for native platform');
    try {
        auth = initializeAuth(app, {
            persistence: [indexedDBLocalPersistence, browserLocalPersistence]
        });
        console.log('[Firebase] Auth initialized with indexedDB persistence');
    } catch (e) {
        console.warn('[Firebase] initializeAuth failed, falling back to getAuth:', e);
        auth = getAuth(app);
    }
} else {
    console.log('[Firebase] Using default persistence for web');
    auth = getAuth(app);
}

// Initialize Firestore
export const db = getFirestore(app);

// Export config for debugging
export const firebaseConfigDebug = {
    apiKey_len: firebaseConfig.apiKey?.length || 0,
    apiKey_prefix: firebaseConfig.apiKey?.substring(0, 6) || '',
    projectId: firebaseConfig.projectId,
    authDomain: firebaseConfig.authDomain
};

export { auth };
export default app;
